import { useQuery } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { IProductOffering } from "../types/products";
import { PaginatedResponse } from "../types/core";

const API = process.env.REACT_APP_API;
const PAGE_SIZE = 100;

const useAllProductOfferings = (fairId: number | null, enabled = true) => {
  const fetch = useFetch();

  return useQuery({
    queryKey: ["product-offerings-all", fairId],
    queryFn: async () => {
      if (!fairId) {
        throw new Error("Fair ID is required");
      }

      const allOfferings: IProductOffering[] = [];
      let nextUrl: string | null =
        `${API}/api/semeadora/fairs/${fairId}/offerings/?page=1&page_size=${PAGE_SIZE}`;

      while (nextUrl) {
        const response = (await fetch(nextUrl, {
          method: "GET",
        })) as PaginatedResponse<IProductOffering>;
        console.log(response);
        allOfferings.push(...response.results);
        nextUrl = response.next;
      }

      return allOfferings;
    },
    enabled: !!fairId && enabled,
  });
};

export default useAllProductOfferings;
